<template>
  <div class="dioptra-product-tabs">
    <div class="native_slider tabs-main-container">
      <ul class="native_slider-lg tabs-product">
        <li class="native_slider-li tab-link"
            @click="setActiveTab(1)"
            data-tab-product="tab-product-1"
            :class="[
              {
                'current': activeTab === 1,
                'disabled': !bookVariation || bookIsFreeEbook
              }
            ]"
        >
          <span>Βιβλίο</span>
          <img src="/ui/main/img/open_book_icon.svg" alt="Βιβλίο" loading="lazy" width="30" height="25" class="img-fluid">
        </li>
        <li class="native_slider-li tab-link"
            @click="setActiveTab(2)"
            data-tab-product="tab-product-2"
            :class="[
              {
                'current': activeTab === 2,
                'disabled': !eBookVariation && !ebookIsFreeEbook
              }
            ]"
        >
          <span>ebook</span>
          <img src="/ui/main/img/mobile_icon.svg" alt="ebook" loading="lazy" width="18" height="25" class="img-fluid">
        </li>
      </ul>
    </div>
    <div v-if="bookVariation && !bookIsFreeEbook && activeTab === 1" id="tab-product-1" class="tab-content-product" :class="activeTab === 1 ? 'current' : ''">
      <div class="dioptra-product-tab-container">
        <div class="dioptra-product-tab-details">
          <div class="dioptra-product-tab-details-title dioptra-product-content-title">
            <span class="dioptra-product-content-title-text">Λεπτομέρειες Βιβλίου</span>
            <span class="dioptra-product-arrow">
              <i class="lni lni-chevron-up"></i>
            </span>
          </div>
          <AdvDioptraProductTabMeta
            :productMetaData="bookProductMetaData"
            :persons="bookPersons"
            :topicsWithoutWarning="productData.topicsWithoutWarning"
            :topicsWithWarning="productData.topicsWithWarning"
          />
        </div>
        <div class="dioptra-product-tab-actions">
          <div class="dioptra-product-tab-actions-buy-add-to-cart">
            <AdvProductPageCard
              class="dioptra-product-page-card-container"
              :product-id="Number(bookVariation.product_id)"
              :product-meta-data="bookProductMetaData"
              :availability-info="availabilityInfo"
            >
              <template v-slot:bundles>
                <slot name="bundles" />
              </template>
              <template v-if="!ebookIsFreeEbook" v-slot:unavailable >
                <slot name="unavailable" />
              </template>
              <template v-slot:prices>
                <div class="dioptra-product-tab-actions-buy">
                  <div class="mt-1 dioptra-product-tab-actions-buy-prices">
                    <div class="dioptra-product-tab-actions-buy-prices-discount-container">
                      <span v-if="bookVariation.translated_disclosure && !getProductChartSettings.enabled" class="dioptra-product-tab-actions-buy-prices-discount">
                          <span>{{ bookVariation.translated_disclosure }}</span>
                      </span>
                      <span v-else-if="getProductChartSettings.enabled && bookVariation.priceTracking.shouldDisplay && bookVariation.priceTracking.discountPass" class="dioptra-product-tab-actions-buy-prices-discount">
                        {{ Number(bookVariation.priceTracking.saveValue * getSelectedCurrency.rate).toFixed(2) }}
                        <span v-html="getSelectedCurrency.symbol"></span>
                      </span>
                    </div>
                    <div class="col-12 dioptra-product-tab-actions-buy-prices-container">
                      <div class="col-12 dioptra-product-tab-author-price-tab">
                      <span v-if="bookVariation.save_price && !getProductChartSettings.enabled" class="dioptra-product-tab-author-price">Τιμή εκδότη</span>
                      <span v-if="bookVariation.save_price && !getProductChartSettings.enabled" class="dioptra-product-tab-actions-buy-prices-starting">
                        {{ Number(bookVariation.price_no_discount_with_vat * getSelectedCurrency.rate).toFixed(2) }}
                        <span v-html="getSelectedCurrency.symbol"></span>
                      </span>
                      <span v-else-if="getProductChartSettings.enabled && bookVariation.priceTracking.shouldDisplay && bookVariation.priceTracking.discountPass" class="dioptra-product-tab-actions-buy-prices-starting">
                        {{ Number(bookVariation.priceTracking.referencePrice * getSelectedCurrency.rate).toFixed(2) }}
                        <span v-html="getSelectedCurrency.symbol"></span>
                      </span>
                      </div>
                      <div class="col-12 dioptra-product-tab-whole-price-tab">
                        <span class="dioptra-product-tab-whole-price">Τιμή elxisbooks.gr</span>
                      <span class="dioptra-product-tab-actions-buy-prices-final">
                        <meta itemprop="priceCurrency" content="EUR"/>
                        <span itemprop="price">
                          {{ Number(bookVariation.final_price * getSelectedCurrency.rate).toFixed(2) }}
                          <span v-html="getSelectedCurrency.symbol"></span>
                        </span>
                      </span>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
              <template v-slot:captcha>
                <slot name="captcha" />
              </template>
            </AdvProductPageCard>
          </div>
        </div>
      </div>
    </div>
    <div v-else-if="eBookVariation && activeTab === 2" id="tab-product-2" class="tab-content-product" :class="activeTab === 2 ? 'current' : ''">
      <div class="dioptra-product-tab-container">
        <div class="dioptra-product-tab-details">
          <div class="dioptra-product-tab-details-title  dioptra-product-content-title">
            <span>Λεπτομέρειες Βιβλίου</span>
            <span class="dioptra-product-arrow">
                <i class="lni lni-chevron-up"></i>
            </span>
          </div>
          <AdvDioptraProductTabMeta
            :productMetaData="eBookProductMetaData"
            :persons="eBookPersons"
            :topicsWithoutWarning="productData.topicsWithoutWarning"
            :topicsWithWarning="productData.topicsWithWarning"
          />
        </div>
        <div class="dioptra-product-tab-actions">
          <div class="dioptra-product-tab-actions-info-wrapper">
            <div class="dioptra-product-tab-actions-info">
              <div v-if="eBookProductMetaData.drm === '1'" class="dioptra-product-tab-details-content">
                <span class="dioptra-product-tab-details-content-title">Προστασία DRM: </span>
                <span class="dioptra-product-tab-details-content-description">Ναι</span>
              </div>
              <div v-if="eBookProductMetaData.epub === '1' || eBookProductMetaData.moby === '1' || eBookProductMetaData.pdf === '1'" class="dioptra-product-tab-details-content">
                <span class="dioptra-product-tab-details-content-title">ebook format: </span>
                <span class="dioptra-product-tab-details-content-description">
                <span v-if="eBookProductMetaData.epub === '1'">epub</span>
                <span v-if="eBookProductMetaData.moby === '1'">moby</span>
                <span v-if="eBookProductMetaData.pdf === '1'">pdf</span>
              </span>
              </div>
              <div v-if="eBookVariation.epub_link || eBookVariation.epub_apple_link" class="dioptra-product-tab-details-content">
                <span class="dioptra-product-tab-details-content-title">Συμβατότητα: </span>
                <span class="dioptra-product-tab-details-content-description">
                {{ determineCompatibility(eBookVariation) }}
              </span>
              </div>
            </div>
            <span v-if="!ebookIsFreeEbook" class="dioptra-product-tab-actions-buy-prices-final mobile">
              <meta itemprop="priceCurrency" content="EUR"/>
              <span itemprop="price">
                {{ Number(eBookVariation.final_price * getSelectedCurrency.rate).toFixed(2) }}
                <span v-html="getSelectedCurrency.symbol"></span>
              </span>
            </span>
          </div>
          <div class="dioptra-product-tab-actions-instructions-container">
            <a class="dioptra-product-tab-actions-instructions" href="/category/voitheia-gia-ta-ebooks" target="_blank">
              <span class="dioptra-product-tab-actions-instructions-text">
                <span class="info-lottie">
                  <Lottie
                    ref="lottie"
                    :animation-data="lottieFile"
                    :auto-play="true"
                    :loop="true"
                    width="20px"
                    height="20px"
                  />
                </span>
                Δες οδηγίες εγκατάστασης των ebooks</span>
            </a>
          </div>
          <div class="dioptra-product-tab-actions-buy-add-to-cart">
            <AdvProductPageCard
              class="dioptra-product-page-card-container"
              :product-id="Number(eBookVariation.product_id)"
              :is-digital="true"
              :epub-apple-link="eBookVariation.epub_apple_link"
              :product-meta-data="eBookProductMetaData"
              :availability-info="availabilityInfo"
            >
              <template v-slot:prices>
                <div v-if="!ebookIsFreeEbook" class="dioptra-product-tab-actions-buy">
                  <div class="dioptra-product-tab-actions-buy-prices">
                    <div class="dioptra-product-tab-actions-buy-prices-discount-container">
                      <span v-if="eBookVariation.translated_disclosure && !getProductChartSettings.enabled" class="dioptra-product-tab-actions-buy-prices-discount">
                          <span>{{ eBookVariation.translated_disclosure }}</span>
                      </span>
                      <span v-else-if="getProductChartSettings.enabled && eBookVariation.priceTracking.shouldDisplay && eBookVariation.priceTracking.discountPass" class="dioptra-product-tab-actions-buy-prices-discount">
                        {{ Number(eBookVariation.priceTracking.saveValue * getSelectedCurrency.rate).toFixed(2) }}
                        <span v-html="getSelectedCurrency.symbol"></span>
                      </span>
                    </div>
                    <div class="dioptra-product-tab-actions-buy-prices-container">
                      <span v-if="eBookVariation.save_price && !getProductChartSettings.enabled" class="dioptra-product-tab-actions-buy-prices-starting">
                        {{ Number(eBookVariation.price_no_discount_with_vat * getSelectedCurrency.rate).toFixed(2) }}
                        <span v-html="getSelectedCurrency.symbol"></span>
                      </span>
                      <span v-else-if="getProductChartSettings.enabled && eBookVariation.priceTracking.shouldDisplay && eBookVariation.priceTracking.discountPass" class="dioptra-product-tab-actions-buy-prices-starting">
                        {{ Number(eBookVariation.priceTracking.referencePrice * getSelectedCurrency.rate).toFixed(2) }}
                        <span v-html="getSelectedCurrency.symbol"></span>
                      </span>
                      <span class="dioptra-product-tab-actions-buy-prices-final desktop">
                        <meta itemprop="priceCurrency" content="EUR"/>
                        <span itemprop="price">
                          {{ Number(eBookVariation.final_price * getSelectedCurrency.rate).toFixed(2) }}
                          <span v-html="getSelectedCurrency.symbol"></span>
                        </span>
                      </span>
                    </div>
                  </div>
                </div>
                <div v-else class="dioptra-product-tab-free-ebook">
                  <span>Το ebook δίνεται <strong>Δωρεάν</strong>!</span>
                </div>
              </template>
              <template v-slot:captcha>
                <slot name="captcha" />
              </template>
            </AdvProductPageCard>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { cloneDeep, forEach } from 'lodash-es'
import { mapGetters } from 'vuex'
import AdvDioptraProductTabMeta from './AdvDioptraProductTabMeta.vue'
import AdvProductPageCard from './AdvProductPageCard.vue'
import Lottie from './Lottie.vue'
import infoLottie from '../lotties/product_page_info_icon.json'

export default {
  name: 'AdvDioptraProductTabs',
  components: {
    AdvDioptraProductTabMeta,
    AdvProductPageCard,
    Lottie
  },
  props: {
    productData: {
      type: Object,
      required: true
    },
    availabilityInfo: {
      type: Object,
      default: () => ({})
    }
  },
  data: () => {
    return {
      bookVariationId: 1,
      eBookVariationId: 2,
      activeTab: null
    }
  },
  mounted () {
    if (this.isEbook || this.bookIsFreeEbook) {
      this.activeTab = 2
    } else {
      this.activeTab = 1
    }
  },
  computed: {
    ...mapGetters([
      'getSelectedCurrency',
      'getRelatedVariationData'
    ]),
    ...mapGetters('productChart', ['getProductChartSettings']),
    bookProductMetaData () {
      return this.bookVariation?.metaData || this.productData?.metaData || null
    },
    bookPersons () {
      return this.bookVariation?.persons || this.productData?.persons || null
    },
    eBookProductMetaData () {
      return this.eBookVariation?.metaData || this.productData?.metaData || null
    },
    eBookPersons () {
      return this.eBookVariation?.persons || this.productData?.persons || null
    },
    currentProductRelatedVariationEntries () {
      const productRelatedVariationEntries = cloneDeep(this.getRelatedVariationData)

      const entries = []
      productRelatedVariationEntries.map(item => {
        forEach(Object.values(item.variations), (variation) => {
          const object = {
            productId: Number(item.product_id),
            variationId: variation.variation_value_id,
            variationGroupId: variation.variation_group_id,
            stock: item.availabilityStock
          }
          entries.push(object)
          return object
        })
      })
      return entries
    },
    bookVariation () {
      const bookFromVariations = this.currentProductRelatedVariationEntries.find(variation => Number(variation.variationId) === this.bookVariationId)
      const bookProduct = this.isEbook ? null : this.productData
      if (!bookFromVariations && bookProduct) return bookProduct
      if (!bookFromVariations && !bookProduct) return null
      const bookProductId = bookFromVariations.productId
      return this.getRelatedVariationData.find(product => Number(product.product_id) === bookProductId)
    },
    eBookVariation () {
      const eBookFromVariations = this.currentProductRelatedVariationEntries.find(variation => Number(variation.variationId) === this.eBookVariationId)
      const eBookProduct = this.isEbook ? this.productData : null
      if (!eBookFromVariations && eBookProduct) return eBookProduct
      if (!eBookFromVariations && !eBookProduct) return null
      const eBookProductId = eBookFromVariations.productId
      return this.getRelatedVariationData.find(product => Number(product.product_id) === eBookProductId)
    },
    isEbook () {
      return this.productData.is_digital === '1'
    },
    lottieFile () {
      return infoLottie
    },
    bookIsFreeEbook () {
      return this.bookVariation?.metaData?.freeEbook === '1'
    },
    ebookIsFreeEbook () {
      return this.eBookVariation?.metaData?.freeEbook === '1'
    },
    eBookVariationUrl () {
      return this.eBookVariation?.productUrl
    },
    bookVariationUrl () {
      return this.bookVariation?.productUrl
    }
  },
  methods: {
    setActiveTab (tabId) {
      if (!this.bookVariation && tabId === 1) return
      if (!this.eBookVariation && tabId === 2) return
      if (this.bookIsFreeEbook && tabId === 1) return
      const navigateTo = tabId === 1 ? this.bookVariationUrl : this.eBookVariationUrl
      if (!navigateTo) {
        return
      }
      window.location.assign(navigateTo)
    },
    setActiveTabFromQueryString () {
      const urlParams = new URLSearchParams(window.location.search)
      const activeTab = urlParams.get('active_tab')
      if (activeTab) {
        this.activeTab = Number(activeTab)
      }
    },
    updateQueryStringParam (key, value) {
      const url = new URL(window.location)
      url.searchParams.set(key, value)
      window.history.pushState({ path: url.href }, '', url.href)
    },
    determineCompatibility (eBookVariation) {
      if (eBookVariation.epub_link && eBookVariation.epub_apple_link) {
        return 'iOS, Android, Windows'
      } else if (eBookVariation.epub_link) {
        return 'Android, Windows'
      } else if (eBookVariation.epub_apple_link) {
        return 'iOS'
      }
      return ''
    }
  }
}
</script>

<style lang="scss" scoped>
.dioptra-product-tab-actions-instructions-container {
  display: flex;
  align-items: center;
  justify-content: center;
  @media screen and (min-width:768px) and (max-width:1199px){
    justify-content: flex-start
  }
}
.dioptra-product-tab-actions-instructions {
  position: relative;
  display: flex;
  gap: 10px;
  padding: 10px;
  border: 1px solid #989898;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
  width:100%;
  @media screen and (max-width: 1199px) {
    margin-bottom: 20px;
  }
}
.dioptra-product-tab-actions-instructions-text {
  color: #231F20;
  font-size: 12px;
  display:flex;
  flex-wrap:wrap;
  width:100%;
  align-items: center;
  justify-content: center
}

.info-lottie{
  flex:0 0 auto;
  max-width: -webkit-fit-content;
  max-width: -moz-fit-content;
  max-width: fit-content;
  margin-right:5px
}

.dioptra-product-tab-actions-buy-add-to-cart {
  display: grid;
  height: 100%;
}
.dioptra-product-tab-actions-info-wrapper {
  display: flex;
  @media screen and (max-width: 1199px) {
    padding-top: 25px;
    justify-content: space-between;
  }
  @media screen and (max-width:359px){
    flex-wrap:wrap;
    width:100%
  }
}
.dioptra-product-tab-actions-buy-prices-final {
  display: block;
  text-align: end;
  @media screen and (max-width:1199px){
    padding-bottom:0;
    padding-left:5px;
    line-height:1
  }
  &.desktop {
    @media screen and (max-width: 1199px) {
      display: none;
    }
  }
  &.mobile {
    padding-bottom: 0;
    @media screen and (min-width: 1200px) {
      display: none;
    }
  }
  @media screen and (max-width:399px){
    font-size:25px
  }
}
.tab-link {
  &.disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }
}
.dioptra-product-tab-free-ebook {
  text-align: center;
  padding-bottom: 10px;
  span {
    font-size: 16px;
    color: #231F20;
    strong {
      color: #D2232A;
    }
  }
}
</style>
